import { render, staticRenderFns } from "./LocationPermissionForm.vue?vue&type=template&id=4cf6241e"
import script from "./LocationPermissionForm.vue?vue&type=script&lang=js"
export * from "./LocationPermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports